<style scoped>
.checkbox-input:checked + svg {
    display: block;
}
.checkbox > .input-container {
    @apply w-6 h-6;
}
.checkbox.checkbox-sm > .input-container {
    @apply w-4 h-4;
}
.checkbox.checkbox-lg > .input-container {
    @apply w-8 h-8;
}
</style>
<template>
    <label class="flex items-center checkbox">
        <div
            class="input-container bg-white border rounded border-gray-100 flex flex-shrink-0 justify-center items-center"
            :class="{ 'mr-4': !!$slots.default }"
        >
            <input
                type="checkbox"
                :checked="value === trueValue"
                :disabled="disabled"
                @change="emitInput"
                class="checkbox-input opacity-0 absolute"
            />
            <svg
                class="fill-current hidden w-full text-darkGrayishBlue  pointer-events-none"
                viewBox="0 0 20 20"
            >
                <path d="M0 11l2-2 5 5L18 3l2 2L7 18z" />
            </svg>
        </div>
        <div class="select-none" v-if="$slots.default"><slot></slot></div>
    </label>
</template>

<script>
export default {
    props: {
        value: {},
        disabled: { default: false },
        trueValue: { default: true },
        falseValue: { default: false }
    },
    methods: {
        emitInput(ev) {
            this.$emit(
                'input',
                ev.target.checked ? this.trueValue : this.falseValue
            );
        }
    }
};
</script>
